/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.chat = (function() {

    /**
     * Namespace chat.
     * @exports chat
     * @namespace
     */
    var chat = {};

    chat.ChatServer = (function() {

        /**
         * Constructs a new ChatServer service.
         * @memberof chat
         * @classdesc Represents a ChatServer
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function ChatServer(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (ChatServer.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ChatServer;

        /**
         * Creates new ChatServer service using the specified rpc implementation.
         * @function create
         * @memberof chat.ChatServer
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {ChatServer} RPC service. Useful where requests and/or responses are streamed.
         */
        ChatServer.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link chat.ChatServer#login}.
         * @memberof chat.ChatServer
         * @typedef LoginCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {chat.Welcome} [response] Welcome
         */

        /**
         * Calls Login.
         * @function login
         * @memberof chat.ChatServer
         * @instance
         * @param {chat.ILoginRequest} request LoginRequest message or plain object
         * @param {chat.ChatServer.LoginCallback} callback Node-style callback called with the error, if any, and Welcome
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ChatServer.prototype.login = function login(request, callback) {
            return this.rpcCall(login, $root.chat.LoginRequest, $root.chat.Welcome, request, callback);
        }, "name", { value: "Login" });

        /**
         * Calls Login.
         * @function login
         * @memberof chat.ChatServer
         * @instance
         * @param {chat.ILoginRequest} request LoginRequest message or plain object
         * @returns {Promise<chat.Welcome>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link chat.ChatServer#sendMessage}.
         * @memberof chat.ChatServer
         * @typedef SendMessageCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {chat.ChatMessage} [response] ChatMessage
         */

        /**
         * Calls SendMessage.
         * @function sendMessage
         * @memberof chat.ChatServer
         * @instance
         * @param {chat.ISendChatMessageRequest} request SendChatMessageRequest message or plain object
         * @param {chat.ChatServer.SendMessageCallback} callback Node-style callback called with the error, if any, and ChatMessage
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ChatServer.prototype.sendMessage = function sendMessage(request, callback) {
            return this.rpcCall(sendMessage, $root.chat.SendChatMessageRequest, $root.chat.ChatMessage, request, callback);
        }, "name", { value: "SendMessage" });

        /**
         * Calls SendMessage.
         * @function sendMessage
         * @memberof chat.ChatServer
         * @instance
         * @param {chat.ISendChatMessageRequest} request SendChatMessageRequest message or plain object
         * @returns {Promise<chat.ChatMessage>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link chat.ChatServer#listChats}.
         * @memberof chat.ChatServer
         * @typedef ListChatsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {chat.Chat} [response] Chat
         */

        /**
         * Calls ListChats.
         * @function listChats
         * @memberof chat.ChatServer
         * @instance
         * @param {chat.IListChatsRequest} request ListChatsRequest message or plain object
         * @param {chat.ChatServer.ListChatsCallback} callback Node-style callback called with the error, if any, and Chat
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ChatServer.prototype.listChats = function listChats(request, callback) {
            return this.rpcCall(listChats, $root.chat.ListChatsRequest, $root.chat.Chat, request, callback);
        }, "name", { value: "ListChats" });

        /**
         * Calls ListChats.
         * @function listChats
         * @memberof chat.ChatServer
         * @instance
         * @param {chat.IListChatsRequest} request ListChatsRequest message or plain object
         * @returns {Promise<chat.Chat>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link chat.ChatServer#replay}.
         * @memberof chat.ChatServer
         * @typedef ReplayCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {chat.ChatMessage} [response] ChatMessage
         */

        /**
         * Calls Replay.
         * @function replay
         * @memberof chat.ChatServer
         * @instance
         * @param {chat.IReplayRequest} request ReplayRequest message or plain object
         * @param {chat.ChatServer.ReplayCallback} callback Node-style callback called with the error, if any, and ChatMessage
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ChatServer.prototype.replay = function replay(request, callback) {
            return this.rpcCall(replay, $root.chat.ReplayRequest, $root.chat.ChatMessage, request, callback);
        }, "name", { value: "Replay" });

        /**
         * Calls Replay.
         * @function replay
         * @memberof chat.ChatServer
         * @instance
         * @param {chat.IReplayRequest} request ReplayRequest message or plain object
         * @returns {Promise<chat.ChatMessage>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link chat.ChatServer#readMessage}.
         * @memberof chat.ChatServer
         * @typedef ReadMessageCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {chat.Ack} [response] Ack
         */

        /**
         * Calls ReadMessage.
         * @function readMessage
         * @memberof chat.ChatServer
         * @instance
         * @param {chat.IMessageReadRequest} request MessageReadRequest message or plain object
         * @param {chat.ChatServer.ReadMessageCallback} callback Node-style callback called with the error, if any, and Ack
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ChatServer.prototype.readMessage = function readMessage(request, callback) {
            return this.rpcCall(readMessage, $root.chat.MessageReadRequest, $root.chat.Ack, request, callback);
        }, "name", { value: "ReadMessage" });

        /**
         * Calls ReadMessage.
         * @function readMessage
         * @memberof chat.ChatServer
         * @instance
         * @param {chat.IMessageReadRequest} request MessageReadRequest message or plain object
         * @returns {Promise<chat.Ack>} Promise
         * @variation 2
         */

        return ChatServer;
    })();

    chat.Response = (function() {

        /**
         * Properties of a Response.
         * @memberof chat
         * @interface IResponse
         * @property {chat.IWelcome|null} [welcome] Response welcome
         * @property {chat.IChat|null} [chat] Response chat
         * @property {chat.IChatMessage|null} [message] Response message
         * @property {chat.IError|null} [error] Response error
         * @property {chat.IAck|null} [ack] Response ack
         */

        /**
         * Constructs a new Response.
         * @memberof chat
         * @classdesc Represents a Response.
         * @implements IResponse
         * @constructor
         * @param {chat.IResponse=} [properties] Properties to set
         */
        function Response(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Response welcome.
         * @member {chat.IWelcome|null|undefined} welcome
         * @memberof chat.Response
         * @instance
         */
        Response.prototype.welcome = null;

        /**
         * Response chat.
         * @member {chat.IChat|null|undefined} chat
         * @memberof chat.Response
         * @instance
         */
        Response.prototype.chat = null;

        /**
         * Response message.
         * @member {chat.IChatMessage|null|undefined} message
         * @memberof chat.Response
         * @instance
         */
        Response.prototype.message = null;

        /**
         * Response error.
         * @member {chat.IError|null|undefined} error
         * @memberof chat.Response
         * @instance
         */
        Response.prototype.error = null;

        /**
         * Response ack.
         * @member {chat.IAck|null|undefined} ack
         * @memberof chat.Response
         * @instance
         */
        Response.prototype.ack = null;

        /**
         * Creates a new Response instance using the specified properties.
         * @function create
         * @memberof chat.Response
         * @static
         * @param {chat.IResponse=} [properties] Properties to set
         * @returns {chat.Response} Response instance
         */
        Response.create = function create(properties) {
            return new Response(properties);
        };

        /**
         * Encodes the specified Response message. Does not implicitly {@link chat.Response.verify|verify} messages.
         * @function encode
         * @memberof chat.Response
         * @static
         * @param {chat.IResponse} message Response message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Response.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.welcome != null && Object.hasOwnProperty.call(message, "welcome"))
                $root.chat.Welcome.encode(message.welcome, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.chat != null && Object.hasOwnProperty.call(message, "chat"))
                $root.chat.Chat.encode(message.chat, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                $root.chat.ChatMessage.encode(message.message, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                $root.chat.Error.encode(message.error, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.ack != null && Object.hasOwnProperty.call(message, "ack"))
                $root.chat.Ack.encode(message.ack, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Response message, length delimited. Does not implicitly {@link chat.Response.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.Response
         * @static
         * @param {chat.IResponse} message Response message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Response.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Response message from the specified reader or buffer.
         * @function decode
         * @memberof chat.Response
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.Response} Response
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Response.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.Response();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.welcome = $root.chat.Welcome.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 2: {
                        message.chat = $root.chat.Chat.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 3: {
                        message.message = $root.chat.ChatMessage.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 4: {
                        message.error = $root.chat.Error.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 5: {
                        message.ack = $root.chat.Ack.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Response message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.Response
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.Response} Response
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Response.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Response message.
         * @function verify
         * @memberof chat.Response
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Response.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            if (message.welcome != null && message.hasOwnProperty("welcome")) {
                var error = $root.chat.Welcome.verify(message.welcome, long + 1);
                if (error)
                    return "welcome." + error;
            }
            if (message.chat != null && message.hasOwnProperty("chat")) {
                var error = $root.chat.Chat.verify(message.chat, long + 1);
                if (error)
                    return "chat." + error;
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                var error = $root.chat.ChatMessage.verify(message.message, long + 1);
                if (error)
                    return "message." + error;
            }
            if (message.error != null && message.hasOwnProperty("error")) {
                var error = $root.chat.Error.verify(message.error, long + 1);
                if (error)
                    return "error." + error;
            }
            if (message.ack != null && message.hasOwnProperty("ack")) {
                var error = $root.chat.Ack.verify(message.ack, long + 1);
                if (error)
                    return "ack." + error;
            }
            return null;
        };

        /**
         * Creates a Response message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.Response
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.Response} Response
         */
        Response.fromObject = function fromObject(object, long) {
            if (object instanceof $root.chat.Response)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var message = new $root.chat.Response();
            if (object.welcome != null) {
                if (typeof object.welcome !== "object")
                    throw TypeError(".chat.Response.welcome: object expected");
                message.welcome = $root.chat.Welcome.fromObject(object.welcome, long + 1);
            }
            if (object.chat != null) {
                if (typeof object.chat !== "object")
                    throw TypeError(".chat.Response.chat: object expected");
                message.chat = $root.chat.Chat.fromObject(object.chat, long + 1);
            }
            if (object.message != null) {
                if (typeof object.message !== "object")
                    throw TypeError(".chat.Response.message: object expected");
                message.message = $root.chat.ChatMessage.fromObject(object.message, long + 1);
            }
            if (object.error != null) {
                if (typeof object.error !== "object")
                    throw TypeError(".chat.Response.error: object expected");
                message.error = $root.chat.Error.fromObject(object.error, long + 1);
            }
            if (object.ack != null) {
                if (typeof object.ack !== "object")
                    throw TypeError(".chat.Response.ack: object expected");
                message.ack = $root.chat.Ack.fromObject(object.ack, long + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from a Response message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.Response
         * @static
         * @param {chat.Response} message Response
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Response.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.welcome = null;
                object.chat = null;
                object.message = null;
                object.error = null;
                object.ack = null;
            }
            if (message.welcome != null && message.hasOwnProperty("welcome"))
                object.welcome = $root.chat.Welcome.toObject(message.welcome, options);
            if (message.chat != null && message.hasOwnProperty("chat"))
                object.chat = $root.chat.Chat.toObject(message.chat, options);
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = $root.chat.ChatMessage.toObject(message.message, options);
            if (message.error != null && message.hasOwnProperty("error"))
                object.error = $root.chat.Error.toObject(message.error, options);
            if (message.ack != null && message.hasOwnProperty("ack"))
                object.ack = $root.chat.Ack.toObject(message.ack, options);
            return object;
        };

        /**
         * Converts this Response to JSON.
         * @function toJSON
         * @memberof chat.Response
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Response.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Response
         * @function getTypeUrl
         * @memberof chat.Response
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.Response";
        };

        return Response;
    })();

    chat.Ack = (function() {

        /**
         * Properties of an Ack.
         * @memberof chat
         * @interface IAck
         */

        /**
         * Constructs a new Ack.
         * @memberof chat
         * @classdesc Represents an Ack.
         * @implements IAck
         * @constructor
         * @param {chat.IAck=} [properties] Properties to set
         */
        function Ack(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Ack instance using the specified properties.
         * @function create
         * @memberof chat.Ack
         * @static
         * @param {chat.IAck=} [properties] Properties to set
         * @returns {chat.Ack} Ack instance
         */
        Ack.create = function create(properties) {
            return new Ack(properties);
        };

        /**
         * Encodes the specified Ack message. Does not implicitly {@link chat.Ack.verify|verify} messages.
         * @function encode
         * @memberof chat.Ack
         * @static
         * @param {chat.IAck} message Ack message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Ack.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Ack message, length delimited. Does not implicitly {@link chat.Ack.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.Ack
         * @static
         * @param {chat.IAck} message Ack message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Ack.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Ack message from the specified reader or buffer.
         * @function decode
         * @memberof chat.Ack
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.Ack} Ack
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Ack.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.Ack();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Ack message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.Ack
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.Ack} Ack
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Ack.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Ack message.
         * @function verify
         * @memberof chat.Ack
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Ack.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            return null;
        };

        /**
         * Creates an Ack message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.Ack
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.Ack} Ack
         */
        Ack.fromObject = function fromObject(object, long) {
            if (object instanceof $root.chat.Ack)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            return new $root.chat.Ack();
        };

        /**
         * Creates a plain object from an Ack message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.Ack
         * @static
         * @param {chat.Ack} message Ack
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Ack.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Ack to JSON.
         * @function toJSON
         * @memberof chat.Ack
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Ack.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Ack
         * @function getTypeUrl
         * @memberof chat.Ack
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Ack.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.Ack";
        };

        return Ack;
    })();

    chat.Welcome = (function() {

        /**
         * Properties of a Welcome.
         * @memberof chat
         * @interface IWelcome
         * @property {string|null} [version] Welcome version
         * @property {number|null} [usersOnline] Welcome usersOnline
         * @property {chat.IAvatar|null} [avatar] Welcome avatar
         */

        /**
         * Constructs a new Welcome.
         * @memberof chat
         * @classdesc Represents a Welcome.
         * @implements IWelcome
         * @constructor
         * @param {chat.IWelcome=} [properties] Properties to set
         */
        function Welcome(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Welcome version.
         * @member {string} version
         * @memberof chat.Welcome
         * @instance
         */
        Welcome.prototype.version = "";

        /**
         * Welcome usersOnline.
         * @member {number} usersOnline
         * @memberof chat.Welcome
         * @instance
         */
        Welcome.prototype.usersOnline = 0;

        /**
         * Welcome avatar.
         * @member {chat.IAvatar|null|undefined} avatar
         * @memberof chat.Welcome
         * @instance
         */
        Welcome.prototype.avatar = null;

        /**
         * Creates a new Welcome instance using the specified properties.
         * @function create
         * @memberof chat.Welcome
         * @static
         * @param {chat.IWelcome=} [properties] Properties to set
         * @returns {chat.Welcome} Welcome instance
         */
        Welcome.create = function create(properties) {
            return new Welcome(properties);
        };

        /**
         * Encodes the specified Welcome message. Does not implicitly {@link chat.Welcome.verify|verify} messages.
         * @function encode
         * @memberof chat.Welcome
         * @static
         * @param {chat.IWelcome} message Welcome message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Welcome.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.version);
            if (message.usersOnline != null && Object.hasOwnProperty.call(message, "usersOnline"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.usersOnline);
            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                $root.chat.Avatar.encode(message.avatar, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Welcome message, length delimited. Does not implicitly {@link chat.Welcome.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.Welcome
         * @static
         * @param {chat.IWelcome} message Welcome message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Welcome.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Welcome message from the specified reader or buffer.
         * @function decode
         * @memberof chat.Welcome
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.Welcome} Welcome
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Welcome.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.Welcome();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.version = reader.string();
                        break;
                    }
                case 2: {
                        message.usersOnline = reader.int32();
                        break;
                    }
                case 3: {
                        message.avatar = $root.chat.Avatar.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Welcome message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.Welcome
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.Welcome} Welcome
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Welcome.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Welcome message.
         * @function verify
         * @memberof chat.Welcome
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Welcome.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            if (message.version != null && message.hasOwnProperty("version"))
                if (!$util.isString(message.version))
                    return "version: string expected";
            if (message.usersOnline != null && message.hasOwnProperty("usersOnline"))
                if (!$util.isInteger(message.usersOnline))
                    return "usersOnline: integer expected";
            if (message.avatar != null && message.hasOwnProperty("avatar")) {
                var error = $root.chat.Avatar.verify(message.avatar, long + 1);
                if (error)
                    return "avatar." + error;
            }
            return null;
        };

        /**
         * Creates a Welcome message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.Welcome
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.Welcome} Welcome
         */
        Welcome.fromObject = function fromObject(object, long) {
            if (object instanceof $root.chat.Welcome)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var message = new $root.chat.Welcome();
            if (object.version != null)
                message.version = String(object.version);
            if (object.usersOnline != null)
                message.usersOnline = object.usersOnline | 0;
            if (object.avatar != null) {
                if (typeof object.avatar !== "object")
                    throw TypeError(".chat.Welcome.avatar: object expected");
                message.avatar = $root.chat.Avatar.fromObject(object.avatar, long + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from a Welcome message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.Welcome
         * @static
         * @param {chat.Welcome} message Welcome
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Welcome.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.version = "";
                object.usersOnline = 0;
                object.avatar = null;
            }
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            if (message.usersOnline != null && message.hasOwnProperty("usersOnline"))
                object.usersOnline = message.usersOnline;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = $root.chat.Avatar.toObject(message.avatar, options);
            return object;
        };

        /**
         * Converts this Welcome to JSON.
         * @function toJSON
         * @memberof chat.Welcome
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Welcome.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Welcome
         * @function getTypeUrl
         * @memberof chat.Welcome
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Welcome.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.Welcome";
        };

        return Welcome;
    })();

    chat.Request = (function() {

        /**
         * Properties of a Request.
         * @memberof chat
         * @interface IRequest
         * @property {chat.ILoginRequest|null} [authenticate] Request authenticate
         * @property {chat.ISendChatMessageRequest|null} [sendMessage] Request sendMessage
         * @property {chat.IListChatsRequest|null} [listChats] Request listChats
         * @property {chat.IReplayRequest|null} [replay] Request replay
         * @property {chat.IMessageReadRequest|null} [messageRead] Request messageRead
         */

        /**
         * Constructs a new Request.
         * @memberof chat
         * @classdesc Represents a Request.
         * @implements IRequest
         * @constructor
         * @param {chat.IRequest=} [properties] Properties to set
         */
        function Request(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Request authenticate.
         * @member {chat.ILoginRequest|null|undefined} authenticate
         * @memberof chat.Request
         * @instance
         */
        Request.prototype.authenticate = null;

        /**
         * Request sendMessage.
         * @member {chat.ISendChatMessageRequest|null|undefined} sendMessage
         * @memberof chat.Request
         * @instance
         */
        Request.prototype.sendMessage = null;

        /**
         * Request listChats.
         * @member {chat.IListChatsRequest|null|undefined} listChats
         * @memberof chat.Request
         * @instance
         */
        Request.prototype.listChats = null;

        /**
         * Request replay.
         * @member {chat.IReplayRequest|null|undefined} replay
         * @memberof chat.Request
         * @instance
         */
        Request.prototype.replay = null;

        /**
         * Request messageRead.
         * @member {chat.IMessageReadRequest|null|undefined} messageRead
         * @memberof chat.Request
         * @instance
         */
        Request.prototype.messageRead = null;

        /**
         * Creates a new Request instance using the specified properties.
         * @function create
         * @memberof chat.Request
         * @static
         * @param {chat.IRequest=} [properties] Properties to set
         * @returns {chat.Request} Request instance
         */
        Request.create = function create(properties) {
            return new Request(properties);
        };

        /**
         * Encodes the specified Request message. Does not implicitly {@link chat.Request.verify|verify} messages.
         * @function encode
         * @memberof chat.Request
         * @static
         * @param {chat.IRequest} message Request message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Request.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.authenticate != null && Object.hasOwnProperty.call(message, "authenticate"))
                $root.chat.LoginRequest.encode(message.authenticate, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.sendMessage != null && Object.hasOwnProperty.call(message, "sendMessage"))
                $root.chat.SendChatMessageRequest.encode(message.sendMessage, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.listChats != null && Object.hasOwnProperty.call(message, "listChats"))
                $root.chat.ListChatsRequest.encode(message.listChats, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.replay != null && Object.hasOwnProperty.call(message, "replay"))
                $root.chat.ReplayRequest.encode(message.replay, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.messageRead != null && Object.hasOwnProperty.call(message, "messageRead"))
                $root.chat.MessageReadRequest.encode(message.messageRead, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Request message, length delimited. Does not implicitly {@link chat.Request.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.Request
         * @static
         * @param {chat.IRequest} message Request message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Request.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Request message from the specified reader or buffer.
         * @function decode
         * @memberof chat.Request
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.Request} Request
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Request.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.Request();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.authenticate = $root.chat.LoginRequest.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 2: {
                        message.sendMessage = $root.chat.SendChatMessageRequest.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 3: {
                        message.listChats = $root.chat.ListChatsRequest.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 4: {
                        message.replay = $root.chat.ReplayRequest.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 5: {
                        message.messageRead = $root.chat.MessageReadRequest.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Request message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.Request
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.Request} Request
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Request.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Request message.
         * @function verify
         * @memberof chat.Request
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Request.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            if (message.authenticate != null && message.hasOwnProperty("authenticate")) {
                var error = $root.chat.LoginRequest.verify(message.authenticate, long + 1);
                if (error)
                    return "authenticate." + error;
            }
            if (message.sendMessage != null && message.hasOwnProperty("sendMessage")) {
                var error = $root.chat.SendChatMessageRequest.verify(message.sendMessage, long + 1);
                if (error)
                    return "sendMessage." + error;
            }
            if (message.listChats != null && message.hasOwnProperty("listChats")) {
                var error = $root.chat.ListChatsRequest.verify(message.listChats, long + 1);
                if (error)
                    return "listChats." + error;
            }
            if (message.replay != null && message.hasOwnProperty("replay")) {
                var error = $root.chat.ReplayRequest.verify(message.replay, long + 1);
                if (error)
                    return "replay." + error;
            }
            if (message.messageRead != null && message.hasOwnProperty("messageRead")) {
                var error = $root.chat.MessageReadRequest.verify(message.messageRead, long + 1);
                if (error)
                    return "messageRead." + error;
            }
            return null;
        };

        /**
         * Creates a Request message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.Request
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.Request} Request
         */
        Request.fromObject = function fromObject(object, long) {
            if (object instanceof $root.chat.Request)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var message = new $root.chat.Request();
            if (object.authenticate != null) {
                if (typeof object.authenticate !== "object")
                    throw TypeError(".chat.Request.authenticate: object expected");
                message.authenticate = $root.chat.LoginRequest.fromObject(object.authenticate, long + 1);
            }
            if (object.sendMessage != null) {
                if (typeof object.sendMessage !== "object")
                    throw TypeError(".chat.Request.sendMessage: object expected");
                message.sendMessage = $root.chat.SendChatMessageRequest.fromObject(object.sendMessage, long + 1);
            }
            if (object.listChats != null) {
                if (typeof object.listChats !== "object")
                    throw TypeError(".chat.Request.listChats: object expected");
                message.listChats = $root.chat.ListChatsRequest.fromObject(object.listChats, long + 1);
            }
            if (object.replay != null) {
                if (typeof object.replay !== "object")
                    throw TypeError(".chat.Request.replay: object expected");
                message.replay = $root.chat.ReplayRequest.fromObject(object.replay, long + 1);
            }
            if (object.messageRead != null) {
                if (typeof object.messageRead !== "object")
                    throw TypeError(".chat.Request.messageRead: object expected");
                message.messageRead = $root.chat.MessageReadRequest.fromObject(object.messageRead, long + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from a Request message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.Request
         * @static
         * @param {chat.Request} message Request
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Request.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.authenticate = null;
                object.sendMessage = null;
                object.listChats = null;
                object.replay = null;
                object.messageRead = null;
            }
            if (message.authenticate != null && message.hasOwnProperty("authenticate"))
                object.authenticate = $root.chat.LoginRequest.toObject(message.authenticate, options);
            if (message.sendMessage != null && message.hasOwnProperty("sendMessage"))
                object.sendMessage = $root.chat.SendChatMessageRequest.toObject(message.sendMessage, options);
            if (message.listChats != null && message.hasOwnProperty("listChats"))
                object.listChats = $root.chat.ListChatsRequest.toObject(message.listChats, options);
            if (message.replay != null && message.hasOwnProperty("replay"))
                object.replay = $root.chat.ReplayRequest.toObject(message.replay, options);
            if (message.messageRead != null && message.hasOwnProperty("messageRead"))
                object.messageRead = $root.chat.MessageReadRequest.toObject(message.messageRead, options);
            return object;
        };

        /**
         * Converts this Request to JSON.
         * @function toJSON
         * @memberof chat.Request
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Request.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Request
         * @function getTypeUrl
         * @memberof chat.Request
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.Request";
        };

        return Request;
    })();

    chat.LoginRequest = (function() {

        /**
         * Properties of a LoginRequest.
         * @memberof chat
         * @interface ILoginRequest
         * @property {string|null} [sessionId] LoginRequest sessionId
         */

        /**
         * Constructs a new LoginRequest.
         * @memberof chat
         * @classdesc Represents a LoginRequest.
         * @implements ILoginRequest
         * @constructor
         * @param {chat.ILoginRequest=} [properties] Properties to set
         */
        function LoginRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LoginRequest sessionId.
         * @member {string} sessionId
         * @memberof chat.LoginRequest
         * @instance
         */
        LoginRequest.prototype.sessionId = "";

        /**
         * Creates a new LoginRequest instance using the specified properties.
         * @function create
         * @memberof chat.LoginRequest
         * @static
         * @param {chat.ILoginRequest=} [properties] Properties to set
         * @returns {chat.LoginRequest} LoginRequest instance
         */
        LoginRequest.create = function create(properties) {
            return new LoginRequest(properties);
        };

        /**
         * Encodes the specified LoginRequest message. Does not implicitly {@link chat.LoginRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.LoginRequest
         * @static
         * @param {chat.ILoginRequest} message LoginRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LoginRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.sessionId);
            return writer;
        };

        /**
         * Encodes the specified LoginRequest message, length delimited. Does not implicitly {@link chat.LoginRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.LoginRequest
         * @static
         * @param {chat.ILoginRequest} message LoginRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LoginRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LoginRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.LoginRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.LoginRequest} LoginRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LoginRequest.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.LoginRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.sessionId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a LoginRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.LoginRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.LoginRequest} LoginRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LoginRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LoginRequest message.
         * @function verify
         * @memberof chat.LoginRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LoginRequest.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            if (message.sessionId != null && message.hasOwnProperty("sessionId"))
                if (!$util.isString(message.sessionId))
                    return "sessionId: string expected";
            return null;
        };

        /**
         * Creates a LoginRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.LoginRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.LoginRequest} LoginRequest
         */
        LoginRequest.fromObject = function fromObject(object, long) {
            if (object instanceof $root.chat.LoginRequest)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var message = new $root.chat.LoginRequest();
            if (object.sessionId != null)
                message.sessionId = String(object.sessionId);
            return message;
        };

        /**
         * Creates a plain object from a LoginRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.LoginRequest
         * @static
         * @param {chat.LoginRequest} message LoginRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LoginRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.sessionId = "";
            if (message.sessionId != null && message.hasOwnProperty("sessionId"))
                object.sessionId = message.sessionId;
            return object;
        };

        /**
         * Converts this LoginRequest to JSON.
         * @function toJSON
         * @memberof chat.LoginRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LoginRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for LoginRequest
         * @function getTypeUrl
         * @memberof chat.LoginRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        LoginRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.LoginRequest";
        };

        return LoginRequest;
    })();

    chat.ReplayRequest = (function() {

        /**
         * Properties of a ReplayRequest.
         * @memberof chat
         * @interface IReplayRequest
         * @property {string|null} [replayFrom] ReplayRequest replayFrom
         * @property {string|null} [chatId] ReplayRequest chatId
         */

        /**
         * Constructs a new ReplayRequest.
         * @memberof chat
         * @classdesc Represents a ReplayRequest.
         * @implements IReplayRequest
         * @constructor
         * @param {chat.IReplayRequest=} [properties] Properties to set
         */
        function ReplayRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReplayRequest replayFrom.
         * @member {string} replayFrom
         * @memberof chat.ReplayRequest
         * @instance
         */
        ReplayRequest.prototype.replayFrom = "";

        /**
         * ReplayRequest chatId.
         * @member {string} chatId
         * @memberof chat.ReplayRequest
         * @instance
         */
        ReplayRequest.prototype.chatId = "";

        /**
         * Creates a new ReplayRequest instance using the specified properties.
         * @function create
         * @memberof chat.ReplayRequest
         * @static
         * @param {chat.IReplayRequest=} [properties] Properties to set
         * @returns {chat.ReplayRequest} ReplayRequest instance
         */
        ReplayRequest.create = function create(properties) {
            return new ReplayRequest(properties);
        };

        /**
         * Encodes the specified ReplayRequest message. Does not implicitly {@link chat.ReplayRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.ReplayRequest
         * @static
         * @param {chat.IReplayRequest} message ReplayRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReplayRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.replayFrom != null && Object.hasOwnProperty.call(message, "replayFrom"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.replayFrom);
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.chatId);
            return writer;
        };

        /**
         * Encodes the specified ReplayRequest message, length delimited. Does not implicitly {@link chat.ReplayRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.ReplayRequest
         * @static
         * @param {chat.IReplayRequest} message ReplayRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReplayRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReplayRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.ReplayRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.ReplayRequest} ReplayRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReplayRequest.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.ReplayRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.replayFrom = reader.string();
                        break;
                    }
                case 2: {
                        message.chatId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReplayRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.ReplayRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.ReplayRequest} ReplayRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReplayRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReplayRequest message.
         * @function verify
         * @memberof chat.ReplayRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReplayRequest.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            if (message.replayFrom != null && message.hasOwnProperty("replayFrom"))
                if (!$util.isString(message.replayFrom))
                    return "replayFrom: string expected";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            return null;
        };

        /**
         * Creates a ReplayRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.ReplayRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.ReplayRequest} ReplayRequest
         */
        ReplayRequest.fromObject = function fromObject(object, long) {
            if (object instanceof $root.chat.ReplayRequest)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var message = new $root.chat.ReplayRequest();
            if (object.replayFrom != null)
                message.replayFrom = String(object.replayFrom);
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            return message;
        };

        /**
         * Creates a plain object from a ReplayRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.ReplayRequest
         * @static
         * @param {chat.ReplayRequest} message ReplayRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReplayRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.replayFrom = "";
                object.chatId = "";
            }
            if (message.replayFrom != null && message.hasOwnProperty("replayFrom"))
                object.replayFrom = message.replayFrom;
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                object.chatId = message.chatId;
            return object;
        };

        /**
         * Converts this ReplayRequest to JSON.
         * @function toJSON
         * @memberof chat.ReplayRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReplayRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ReplayRequest
         * @function getTypeUrl
         * @memberof chat.ReplayRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ReplayRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.ReplayRequest";
        };

        return ReplayRequest;
    })();

    chat.ListChatsRequest = (function() {

        /**
         * Properties of a ListChatsRequest.
         * @memberof chat
         * @interface IListChatsRequest
         */

        /**
         * Constructs a new ListChatsRequest.
         * @memberof chat
         * @classdesc Represents a ListChatsRequest.
         * @implements IListChatsRequest
         * @constructor
         * @param {chat.IListChatsRequest=} [properties] Properties to set
         */
        function ListChatsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ListChatsRequest instance using the specified properties.
         * @function create
         * @memberof chat.ListChatsRequest
         * @static
         * @param {chat.IListChatsRequest=} [properties] Properties to set
         * @returns {chat.ListChatsRequest} ListChatsRequest instance
         */
        ListChatsRequest.create = function create(properties) {
            return new ListChatsRequest(properties);
        };

        /**
         * Encodes the specified ListChatsRequest message. Does not implicitly {@link chat.ListChatsRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.ListChatsRequest
         * @static
         * @param {chat.IListChatsRequest} message ListChatsRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListChatsRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified ListChatsRequest message, length delimited. Does not implicitly {@link chat.ListChatsRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.ListChatsRequest
         * @static
         * @param {chat.IListChatsRequest} message ListChatsRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListChatsRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListChatsRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.ListChatsRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.ListChatsRequest} ListChatsRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListChatsRequest.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.ListChatsRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListChatsRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.ListChatsRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.ListChatsRequest} ListChatsRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListChatsRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListChatsRequest message.
         * @function verify
         * @memberof chat.ListChatsRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListChatsRequest.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            return null;
        };

        /**
         * Creates a ListChatsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.ListChatsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.ListChatsRequest} ListChatsRequest
         */
        ListChatsRequest.fromObject = function fromObject(object, long) {
            if (object instanceof $root.chat.ListChatsRequest)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            return new $root.chat.ListChatsRequest();
        };

        /**
         * Creates a plain object from a ListChatsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.ListChatsRequest
         * @static
         * @param {chat.ListChatsRequest} message ListChatsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListChatsRequest.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ListChatsRequest to JSON.
         * @function toJSON
         * @memberof chat.ListChatsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListChatsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListChatsRequest
         * @function getTypeUrl
         * @memberof chat.ListChatsRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListChatsRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.ListChatsRequest";
        };

        return ListChatsRequest;
    })();

    chat.MessageReadRequest = (function() {

        /**
         * Properties of a MessageReadRequest.
         * @memberof chat
         * @interface IMessageReadRequest
         * @property {string|null} [chatId] MessageReadRequest chatId
         * @property {string|null} [messageId] MessageReadRequest messageId
         */

        /**
         * Constructs a new MessageReadRequest.
         * @memberof chat
         * @classdesc Represents a MessageReadRequest.
         * @implements IMessageReadRequest
         * @constructor
         * @param {chat.IMessageReadRequest=} [properties] Properties to set
         */
        function MessageReadRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessageReadRequest chatId.
         * @member {string} chatId
         * @memberof chat.MessageReadRequest
         * @instance
         */
        MessageReadRequest.prototype.chatId = "";

        /**
         * MessageReadRequest messageId.
         * @member {string} messageId
         * @memberof chat.MessageReadRequest
         * @instance
         */
        MessageReadRequest.prototype.messageId = "";

        /**
         * Creates a new MessageReadRequest instance using the specified properties.
         * @function create
         * @memberof chat.MessageReadRequest
         * @static
         * @param {chat.IMessageReadRequest=} [properties] Properties to set
         * @returns {chat.MessageReadRequest} MessageReadRequest instance
         */
        MessageReadRequest.create = function create(properties) {
            return new MessageReadRequest(properties);
        };

        /**
         * Encodes the specified MessageReadRequest message. Does not implicitly {@link chat.MessageReadRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.MessageReadRequest
         * @static
         * @param {chat.IMessageReadRequest} message MessageReadRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageReadRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.chatId);
            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.messageId);
            return writer;
        };

        /**
         * Encodes the specified MessageReadRequest message, length delimited. Does not implicitly {@link chat.MessageReadRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.MessageReadRequest
         * @static
         * @param {chat.IMessageReadRequest} message MessageReadRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageReadRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessageReadRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.MessageReadRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.MessageReadRequest} MessageReadRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageReadRequest.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.MessageReadRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.chatId = reader.string();
                        break;
                    }
                case 2: {
                        message.messageId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessageReadRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.MessageReadRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.MessageReadRequest} MessageReadRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageReadRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessageReadRequest message.
         * @function verify
         * @memberof chat.MessageReadRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessageReadRequest.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            return null;
        };

        /**
         * Creates a MessageReadRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.MessageReadRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.MessageReadRequest} MessageReadRequest
         */
        MessageReadRequest.fromObject = function fromObject(object, long) {
            if (object instanceof $root.chat.MessageReadRequest)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var message = new $root.chat.MessageReadRequest();
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            if (object.messageId != null)
                message.messageId = String(object.messageId);
            return message;
        };

        /**
         * Creates a plain object from a MessageReadRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.MessageReadRequest
         * @static
         * @param {chat.MessageReadRequest} message MessageReadRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageReadRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.chatId = "";
                object.messageId = "";
            }
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                object.chatId = message.chatId;
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                object.messageId = message.messageId;
            return object;
        };

        /**
         * Converts this MessageReadRequest to JSON.
         * @function toJSON
         * @memberof chat.MessageReadRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessageReadRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MessageReadRequest
         * @function getTypeUrl
         * @memberof chat.MessageReadRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MessageReadRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.MessageReadRequest";
        };

        return MessageReadRequest;
    })();

    /**
     * ErrorCode enum.
     * @name chat.ErrorCode
     * @enum {number}
     * @property {number} Unspecified=0 Unspecified value
     * @property {number} Unauthenticated=1 Unauthenticated value
     * @property {number} Unauthorized=2 Unauthorized value
     * @property {number} InvalidParams=3 InvalidParams value
     */
    chat.ErrorCode = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Unspecified"] = 0;
        values[valuesById[1] = "Unauthenticated"] = 1;
        values[valuesById[2] = "Unauthorized"] = 2;
        values[valuesById[3] = "InvalidParams"] = 3;
        return values;
    })();

    chat.Error = (function() {

        /**
         * Properties of an Error.
         * @memberof chat
         * @interface IError
         * @property {chat.ErrorCode|null} [code] Error code
         * @property {string|null} [message] Error message
         * @property {string|null} [clientMessageId] Error clientMessageId
         */

        /**
         * Constructs a new Error.
         * @memberof chat
         * @classdesc Represents an Error.
         * @implements IError
         * @constructor
         * @param {chat.IError=} [properties] Properties to set
         */
        function Error(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Error code.
         * @member {chat.ErrorCode} code
         * @memberof chat.Error
         * @instance
         */
        Error.prototype.code = 0;

        /**
         * Error message.
         * @member {string} message
         * @memberof chat.Error
         * @instance
         */
        Error.prototype.message = "";

        /**
         * Error clientMessageId.
         * @member {string} clientMessageId
         * @memberof chat.Error
         * @instance
         */
        Error.prototype.clientMessageId = "";

        /**
         * Creates a new Error instance using the specified properties.
         * @function create
         * @memberof chat.Error
         * @static
         * @param {chat.IError=} [properties] Properties to set
         * @returns {chat.Error} Error instance
         */
        Error.create = function create(properties) {
            return new Error(properties);
        };

        /**
         * Encodes the specified Error message. Does not implicitly {@link chat.Error.verify|verify} messages.
         * @function encode
         * @memberof chat.Error
         * @static
         * @param {chat.IError} message Error message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Error.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            if (message.clientMessageId != null && Object.hasOwnProperty.call(message, "clientMessageId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.clientMessageId);
            return writer;
        };

        /**
         * Encodes the specified Error message, length delimited. Does not implicitly {@link chat.Error.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.Error
         * @static
         * @param {chat.IError} message Error message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Error.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Error message from the specified reader or buffer.
         * @function decode
         * @memberof chat.Error
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.Error} Error
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Error.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.Error();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.code = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                case 3: {
                        message.clientMessageId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Error message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.Error
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.Error} Error
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Error.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Error message.
         * @function verify
         * @memberof chat.Error
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Error.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            if (message.code != null && message.hasOwnProperty("code"))
                switch (message.code) {
                default:
                    return "code: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            if (message.clientMessageId != null && message.hasOwnProperty("clientMessageId"))
                if (!$util.isString(message.clientMessageId))
                    return "clientMessageId: string expected";
            return null;
        };

        /**
         * Creates an Error message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.Error
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.Error} Error
         */
        Error.fromObject = function fromObject(object, long) {
            if (object instanceof $root.chat.Error)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var message = new $root.chat.Error();
            switch (object.code) {
            default:
                if (typeof object.code === "number") {
                    message.code = object.code;
                    break;
                }
                break;
            case "Unspecified":
            case 0:
                message.code = 0;
                break;
            case "Unauthenticated":
            case 1:
                message.code = 1;
                break;
            case "Unauthorized":
            case 2:
                message.code = 2;
                break;
            case "InvalidParams":
            case 3:
                message.code = 3;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.clientMessageId != null)
                message.clientMessageId = String(object.clientMessageId);
            return message;
        };

        /**
         * Creates a plain object from an Error message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.Error
         * @static
         * @param {chat.Error} message Error
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Error.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.code = options.enums === String ? "Unspecified" : 0;
                object.message = "";
                object.clientMessageId = "";
            }
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = options.enums === String ? $root.chat.ErrorCode[message.code] === undefined ? message.code : $root.chat.ErrorCode[message.code] : message.code;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            if (message.clientMessageId != null && message.hasOwnProperty("clientMessageId"))
                object.clientMessageId = message.clientMessageId;
            return object;
        };

        /**
         * Converts this Error to JSON.
         * @function toJSON
         * @memberof chat.Error
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Error.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Error
         * @function getTypeUrl
         * @memberof chat.Error
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.Error";
        };

        return Error;
    })();

    chat.EventRef = (function() {

        /**
         * Properties of an EventRef.
         * @memberof chat
         * @interface IEventRef
         * @property {string|null} [id] EventRef id
         * @property {string|null} [thumbnailId] EventRef thumbnailId
         * @property {string|null} [color] EventRef color
         * @property {string|null} [title] EventRef title
         */

        /**
         * Constructs a new EventRef.
         * @memberof chat
         * @classdesc Represents an EventRef.
         * @implements IEventRef
         * @constructor
         * @param {chat.IEventRef=} [properties] Properties to set
         */
        function EventRef(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EventRef id.
         * @member {string} id
         * @memberof chat.EventRef
         * @instance
         */
        EventRef.prototype.id = "";

        /**
         * EventRef thumbnailId.
         * @member {string} thumbnailId
         * @memberof chat.EventRef
         * @instance
         */
        EventRef.prototype.thumbnailId = "";

        /**
         * EventRef color.
         * @member {string} color
         * @memberof chat.EventRef
         * @instance
         */
        EventRef.prototype.color = "";

        /**
         * EventRef title.
         * @member {string} title
         * @memberof chat.EventRef
         * @instance
         */
        EventRef.prototype.title = "";

        /**
         * Creates a new EventRef instance using the specified properties.
         * @function create
         * @memberof chat.EventRef
         * @static
         * @param {chat.IEventRef=} [properties] Properties to set
         * @returns {chat.EventRef} EventRef instance
         */
        EventRef.create = function create(properties) {
            return new EventRef(properties);
        };

        /**
         * Encodes the specified EventRef message. Does not implicitly {@link chat.EventRef.verify|verify} messages.
         * @function encode
         * @memberof chat.EventRef
         * @static
         * @param {chat.IEventRef} message EventRef message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EventRef.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.thumbnailId != null && Object.hasOwnProperty.call(message, "thumbnailId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.thumbnailId);
            if (message.color != null && Object.hasOwnProperty.call(message, "color"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.color);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.title);
            return writer;
        };

        /**
         * Encodes the specified EventRef message, length delimited. Does not implicitly {@link chat.EventRef.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.EventRef
         * @static
         * @param {chat.IEventRef} message EventRef message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EventRef.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EventRef message from the specified reader or buffer.
         * @function decode
         * @memberof chat.EventRef
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.EventRef} EventRef
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EventRef.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.EventRef();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.thumbnailId = reader.string();
                        break;
                    }
                case 3: {
                        message.color = reader.string();
                        break;
                    }
                case 4: {
                        message.title = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EventRef message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.EventRef
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.EventRef} EventRef
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EventRef.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EventRef message.
         * @function verify
         * @memberof chat.EventRef
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EventRef.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.thumbnailId != null && message.hasOwnProperty("thumbnailId"))
                if (!$util.isString(message.thumbnailId))
                    return "thumbnailId: string expected";
            if (message.color != null && message.hasOwnProperty("color"))
                if (!$util.isString(message.color))
                    return "color: string expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            return null;
        };

        /**
         * Creates an EventRef message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.EventRef
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.EventRef} EventRef
         */
        EventRef.fromObject = function fromObject(object, long) {
            if (object instanceof $root.chat.EventRef)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var message = new $root.chat.EventRef();
            if (object.id != null)
                message.id = String(object.id);
            if (object.thumbnailId != null)
                message.thumbnailId = String(object.thumbnailId);
            if (object.color != null)
                message.color = String(object.color);
            if (object.title != null)
                message.title = String(object.title);
            return message;
        };

        /**
         * Creates a plain object from an EventRef message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.EventRef
         * @static
         * @param {chat.EventRef} message EventRef
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EventRef.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.thumbnailId = "";
                object.color = "";
                object.title = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.thumbnailId != null && message.hasOwnProperty("thumbnailId"))
                object.thumbnailId = message.thumbnailId;
            if (message.color != null && message.hasOwnProperty("color"))
                object.color = message.color;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            return object;
        };

        /**
         * Converts this EventRef to JSON.
         * @function toJSON
         * @memberof chat.EventRef
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EventRef.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for EventRef
         * @function getTypeUrl
         * @memberof chat.EventRef
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        EventRef.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.EventRef";
        };

        return EventRef;
    })();

    chat.GroupRef = (function() {

        /**
         * Properties of a GroupRef.
         * @memberof chat
         * @interface IGroupRef
         * @property {string|null} [id] GroupRef id
         * @property {string|null} [thumbnailId] GroupRef thumbnailId
         * @property {string|null} [color] GroupRef color
         * @property {string|null} [name] GroupRef name
         */

        /**
         * Constructs a new GroupRef.
         * @memberof chat
         * @classdesc Represents a GroupRef.
         * @implements IGroupRef
         * @constructor
         * @param {chat.IGroupRef=} [properties] Properties to set
         */
        function GroupRef(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GroupRef id.
         * @member {string} id
         * @memberof chat.GroupRef
         * @instance
         */
        GroupRef.prototype.id = "";

        /**
         * GroupRef thumbnailId.
         * @member {string} thumbnailId
         * @memberof chat.GroupRef
         * @instance
         */
        GroupRef.prototype.thumbnailId = "";

        /**
         * GroupRef color.
         * @member {string} color
         * @memberof chat.GroupRef
         * @instance
         */
        GroupRef.prototype.color = "";

        /**
         * GroupRef name.
         * @member {string} name
         * @memberof chat.GroupRef
         * @instance
         */
        GroupRef.prototype.name = "";

        /**
         * Creates a new GroupRef instance using the specified properties.
         * @function create
         * @memberof chat.GroupRef
         * @static
         * @param {chat.IGroupRef=} [properties] Properties to set
         * @returns {chat.GroupRef} GroupRef instance
         */
        GroupRef.create = function create(properties) {
            return new GroupRef(properties);
        };

        /**
         * Encodes the specified GroupRef message. Does not implicitly {@link chat.GroupRef.verify|verify} messages.
         * @function encode
         * @memberof chat.GroupRef
         * @static
         * @param {chat.IGroupRef} message GroupRef message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GroupRef.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.thumbnailId != null && Object.hasOwnProperty.call(message, "thumbnailId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.thumbnailId);
            if (message.color != null && Object.hasOwnProperty.call(message, "color"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.color);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.name);
            return writer;
        };

        /**
         * Encodes the specified GroupRef message, length delimited. Does not implicitly {@link chat.GroupRef.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.GroupRef
         * @static
         * @param {chat.IGroupRef} message GroupRef message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GroupRef.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GroupRef message from the specified reader or buffer.
         * @function decode
         * @memberof chat.GroupRef
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.GroupRef} GroupRef
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GroupRef.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.GroupRef();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.thumbnailId = reader.string();
                        break;
                    }
                case 3: {
                        message.color = reader.string();
                        break;
                    }
                case 4: {
                        message.name = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GroupRef message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.GroupRef
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.GroupRef} GroupRef
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GroupRef.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GroupRef message.
         * @function verify
         * @memberof chat.GroupRef
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GroupRef.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.thumbnailId != null && message.hasOwnProperty("thumbnailId"))
                if (!$util.isString(message.thumbnailId))
                    return "thumbnailId: string expected";
            if (message.color != null && message.hasOwnProperty("color"))
                if (!$util.isString(message.color))
                    return "color: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            return null;
        };

        /**
         * Creates a GroupRef message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.GroupRef
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.GroupRef} GroupRef
         */
        GroupRef.fromObject = function fromObject(object, long) {
            if (object instanceof $root.chat.GroupRef)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var message = new $root.chat.GroupRef();
            if (object.id != null)
                message.id = String(object.id);
            if (object.thumbnailId != null)
                message.thumbnailId = String(object.thumbnailId);
            if (object.color != null)
                message.color = String(object.color);
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        /**
         * Creates a plain object from a GroupRef message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.GroupRef
         * @static
         * @param {chat.GroupRef} message GroupRef
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GroupRef.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.thumbnailId = "";
                object.color = "";
                object.name = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.thumbnailId != null && message.hasOwnProperty("thumbnailId"))
                object.thumbnailId = message.thumbnailId;
            if (message.color != null && message.hasOwnProperty("color"))
                object.color = message.color;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            return object;
        };

        /**
         * Converts this GroupRef to JSON.
         * @function toJSON
         * @memberof chat.GroupRef
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GroupRef.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GroupRef
         * @function getTypeUrl
         * @memberof chat.GroupRef
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GroupRef.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.GroupRef";
        };

        return GroupRef;
    })();

    chat.Chat = (function() {

        /**
         * Properties of a Chat.
         * @memberof chat
         * @interface IChat
         * @property {string|null} [id] Chat id
         * @property {string|null} [name] Chat name
         * @property {chat.ITimestamp|null} [lastActivity] Chat lastActivity
         * @property {chat.ITimestamp|null} [lockedAt] Chat lockedAt
         * @property {chat.ITimestamp|null} [deletedAt] Chat deletedAt
         * @property {boolean|null} [hidden] Chat hidden
         * @property {boolean|null} [muted] Chat muted
         * @property {string|null} [lastReadMessage] Chat lastReadMessage
         * @property {Array.<chat.IAvatar>|null} [participants] Chat participants
         * @property {chat.IEventRef|null} [event] Chat event
         * @property {chat.IGroupRef|null} [group] Chat group
         * @property {chat.IAvatar|null} [user] Chat user
         */

        /**
         * Constructs a new Chat.
         * @memberof chat
         * @classdesc Represents a Chat.
         * @implements IChat
         * @constructor
         * @param {chat.IChat=} [properties] Properties to set
         */
        function Chat(properties) {
            this.participants = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Chat id.
         * @member {string} id
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.id = "";

        /**
         * Chat name.
         * @member {string} name
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.name = "";

        /**
         * Chat lastActivity.
         * @member {chat.ITimestamp|null|undefined} lastActivity
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.lastActivity = null;

        /**
         * Chat lockedAt.
         * @member {chat.ITimestamp|null|undefined} lockedAt
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.lockedAt = null;

        /**
         * Chat deletedAt.
         * @member {chat.ITimestamp|null|undefined} deletedAt
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.deletedAt = null;

        /**
         * Chat hidden.
         * @member {boolean} hidden
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.hidden = false;

        /**
         * Chat muted.
         * @member {boolean} muted
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.muted = false;

        /**
         * Chat lastReadMessage.
         * @member {string} lastReadMessage
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.lastReadMessage = "";

        /**
         * Chat participants.
         * @member {Array.<chat.IAvatar>} participants
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.participants = $util.emptyArray;

        /**
         * Chat event.
         * @member {chat.IEventRef|null|undefined} event
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.event = null;

        /**
         * Chat group.
         * @member {chat.IGroupRef|null|undefined} group
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.group = null;

        /**
         * Chat user.
         * @member {chat.IAvatar|null|undefined} user
         * @memberof chat.Chat
         * @instance
         */
        Chat.prototype.user = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * Chat attachedTo.
         * @member {"event"|"group"|"user"|undefined} attachedTo
         * @memberof chat.Chat
         * @instance
         */
        Object.defineProperty(Chat.prototype, "attachedTo", {
            get: $util.oneOfGetter($oneOfFields = ["event", "group", "user"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Chat instance using the specified properties.
         * @function create
         * @memberof chat.Chat
         * @static
         * @param {chat.IChat=} [properties] Properties to set
         * @returns {chat.Chat} Chat instance
         */
        Chat.create = function create(properties) {
            return new Chat(properties);
        };

        /**
         * Encodes the specified Chat message. Does not implicitly {@link chat.Chat.verify|verify} messages.
         * @function encode
         * @memberof chat.Chat
         * @static
         * @param {chat.IChat} message Chat message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Chat.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.lastActivity != null && Object.hasOwnProperty.call(message, "lastActivity"))
                $root.chat.Timestamp.encode(message.lastActivity, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.lockedAt != null && Object.hasOwnProperty.call(message, "lockedAt"))
                $root.chat.Timestamp.encode(message.lockedAt, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.deletedAt != null && Object.hasOwnProperty.call(message, "deletedAt"))
                $root.chat.Timestamp.encode(message.deletedAt, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.hidden != null && Object.hasOwnProperty.call(message, "hidden"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.hidden);
            if (message.muted != null && Object.hasOwnProperty.call(message, "muted"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.muted);
            if (message.lastReadMessage != null && Object.hasOwnProperty.call(message, "lastReadMessage"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.lastReadMessage);
            if (message.participants != null && message.participants.length)
                for (var i = 0; i < message.participants.length; ++i)
                    $root.chat.Avatar.encode(message.participants[i], writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
            if (message.event != null && Object.hasOwnProperty.call(message, "event"))
                $root.chat.EventRef.encode(message.event, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
            if (message.group != null && Object.hasOwnProperty.call(message, "group"))
                $root.chat.GroupRef.encode(message.group, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
            if (message.user != null && Object.hasOwnProperty.call(message, "user"))
                $root.chat.Avatar.encode(message.user, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Chat message, length delimited. Does not implicitly {@link chat.Chat.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.Chat
         * @static
         * @param {chat.IChat} message Chat message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Chat.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Chat message from the specified reader or buffer.
         * @function decode
         * @memberof chat.Chat
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.Chat} Chat
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Chat.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.Chat();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.name = reader.string();
                        break;
                    }
                case 3: {
                        message.lastActivity = $root.chat.Timestamp.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 4: {
                        message.lockedAt = $root.chat.Timestamp.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 5: {
                        message.deletedAt = $root.chat.Timestamp.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 6: {
                        message.hidden = reader.bool();
                        break;
                    }
                case 7: {
                        message.muted = reader.bool();
                        break;
                    }
                case 8: {
                        message.lastReadMessage = reader.string();
                        break;
                    }
                case 9: {
                        if (!(message.participants && message.participants.length))
                            message.participants = [];
                        message.participants.push($root.chat.Avatar.decode(reader, reader.uint32(), undefined, long + 1));
                        break;
                    }
                case 10: {
                        message.event = $root.chat.EventRef.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 11: {
                        message.group = $root.chat.GroupRef.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 12: {
                        message.user = $root.chat.Avatar.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Chat message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.Chat
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.Chat} Chat
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Chat.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Chat message.
         * @function verify
         * @memberof chat.Chat
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Chat.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            var properties = {};
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.lastActivity != null && message.hasOwnProperty("lastActivity")) {
                var error = $root.chat.Timestamp.verify(message.lastActivity, long + 1);
                if (error)
                    return "lastActivity." + error;
            }
            if (message.lockedAt != null && message.hasOwnProperty("lockedAt")) {
                var error = $root.chat.Timestamp.verify(message.lockedAt, long + 1);
                if (error)
                    return "lockedAt." + error;
            }
            if (message.deletedAt != null && message.hasOwnProperty("deletedAt")) {
                var error = $root.chat.Timestamp.verify(message.deletedAt, long + 1);
                if (error)
                    return "deletedAt." + error;
            }
            if (message.hidden != null && message.hasOwnProperty("hidden"))
                if (typeof message.hidden !== "boolean")
                    return "hidden: boolean expected";
            if (message.muted != null && message.hasOwnProperty("muted"))
                if (typeof message.muted !== "boolean")
                    return "muted: boolean expected";
            if (message.lastReadMessage != null && message.hasOwnProperty("lastReadMessage"))
                if (!$util.isString(message.lastReadMessage))
                    return "lastReadMessage: string expected";
            if (message.participants != null && message.hasOwnProperty("participants")) {
                if (!Array.isArray(message.participants))
                    return "participants: array expected";
                for (var i = 0; i < message.participants.length; ++i) {
                    var error = $root.chat.Avatar.verify(message.participants[i], long + 1);
                    if (error)
                        return "participants." + error;
                }
            }
            if (message.event != null && message.hasOwnProperty("event")) {
                properties.attachedTo = 1;
                {
                    var error = $root.chat.EventRef.verify(message.event, long + 1);
                    if (error)
                        return "event." + error;
                }
            }
            if (message.group != null && message.hasOwnProperty("group")) {
                if (properties.attachedTo === 1)
                    return "attachedTo: multiple values";
                properties.attachedTo = 1;
                {
                    var error = $root.chat.GroupRef.verify(message.group, long + 1);
                    if (error)
                        return "group." + error;
                }
            }
            if (message.user != null && message.hasOwnProperty("user")) {
                if (properties.attachedTo === 1)
                    return "attachedTo: multiple values";
                properties.attachedTo = 1;
                {
                    var error = $root.chat.Avatar.verify(message.user, long + 1);
                    if (error)
                        return "user." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Chat message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.Chat
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.Chat} Chat
         */
        Chat.fromObject = function fromObject(object, long) {
            if (object instanceof $root.chat.Chat)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var message = new $root.chat.Chat();
            if (object.id != null)
                message.id = String(object.id);
            if (object.name != null)
                message.name = String(object.name);
            if (object.lastActivity != null) {
                if (typeof object.lastActivity !== "object")
                    throw TypeError(".chat.Chat.lastActivity: object expected");
                message.lastActivity = $root.chat.Timestamp.fromObject(object.lastActivity, long + 1);
            }
            if (object.lockedAt != null) {
                if (typeof object.lockedAt !== "object")
                    throw TypeError(".chat.Chat.lockedAt: object expected");
                message.lockedAt = $root.chat.Timestamp.fromObject(object.lockedAt, long + 1);
            }
            if (object.deletedAt != null) {
                if (typeof object.deletedAt !== "object")
                    throw TypeError(".chat.Chat.deletedAt: object expected");
                message.deletedAt = $root.chat.Timestamp.fromObject(object.deletedAt, long + 1);
            }
            if (object.hidden != null)
                message.hidden = Boolean(object.hidden);
            if (object.muted != null)
                message.muted = Boolean(object.muted);
            if (object.lastReadMessage != null)
                message.lastReadMessage = String(object.lastReadMessage);
            if (object.participants) {
                if (!Array.isArray(object.participants))
                    throw TypeError(".chat.Chat.participants: array expected");
                message.participants = [];
                for (var i = 0; i < object.participants.length; ++i) {
                    if (typeof object.participants[i] !== "object")
                        throw TypeError(".chat.Chat.participants: object expected");
                    message.participants[i] = $root.chat.Avatar.fromObject(object.participants[i], long + 1);
                }
            }
            if (object.event != null) {
                if (typeof object.event !== "object")
                    throw TypeError(".chat.Chat.event: object expected");
                message.event = $root.chat.EventRef.fromObject(object.event, long + 1);
            }
            if (object.group != null) {
                if (typeof object.group !== "object")
                    throw TypeError(".chat.Chat.group: object expected");
                message.group = $root.chat.GroupRef.fromObject(object.group, long + 1);
            }
            if (object.user != null) {
                if (typeof object.user !== "object")
                    throw TypeError(".chat.Chat.user: object expected");
                message.user = $root.chat.Avatar.fromObject(object.user, long + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from a Chat message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.Chat
         * @static
         * @param {chat.Chat} message Chat
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Chat.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.participants = [];
            if (options.defaults) {
                object.id = "";
                object.name = "";
                object.lastActivity = null;
                object.lockedAt = null;
                object.deletedAt = null;
                object.hidden = false;
                object.muted = false;
                object.lastReadMessage = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.lastActivity != null && message.hasOwnProperty("lastActivity"))
                object.lastActivity = $root.chat.Timestamp.toObject(message.lastActivity, options);
            if (message.lockedAt != null && message.hasOwnProperty("lockedAt"))
                object.lockedAt = $root.chat.Timestamp.toObject(message.lockedAt, options);
            if (message.deletedAt != null && message.hasOwnProperty("deletedAt"))
                object.deletedAt = $root.chat.Timestamp.toObject(message.deletedAt, options);
            if (message.hidden != null && message.hasOwnProperty("hidden"))
                object.hidden = message.hidden;
            if (message.muted != null && message.hasOwnProperty("muted"))
                object.muted = message.muted;
            if (message.lastReadMessage != null && message.hasOwnProperty("lastReadMessage"))
                object.lastReadMessage = message.lastReadMessage;
            if (message.participants && message.participants.length) {
                object.participants = [];
                for (var j = 0; j < message.participants.length; ++j)
                    object.participants[j] = $root.chat.Avatar.toObject(message.participants[j], options);
            }
            if (message.event != null && message.hasOwnProperty("event")) {
                object.event = $root.chat.EventRef.toObject(message.event, options);
                if (options.oneofs)
                    object.attachedTo = "event";
            }
            if (message.group != null && message.hasOwnProperty("group")) {
                object.group = $root.chat.GroupRef.toObject(message.group, options);
                if (options.oneofs)
                    object.attachedTo = "group";
            }
            if (message.user != null && message.hasOwnProperty("user")) {
                object.user = $root.chat.Avatar.toObject(message.user, options);
                if (options.oneofs)
                    object.attachedTo = "user";
            }
            return object;
        };

        /**
         * Converts this Chat to JSON.
         * @function toJSON
         * @memberof chat.Chat
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Chat.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Chat
         * @function getTypeUrl
         * @memberof chat.Chat
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Chat.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.Chat";
        };

        return Chat;
    })();

    chat.Avatar = (function() {

        /**
         * Properties of an Avatar.
         * @memberof chat
         * @interface IAvatar
         * @property {number|null} [id] Avatar id
         * @property {string|null} [username] Avatar username
         * @property {string|null} [gecos] Avatar gecos
         * @property {string|null} [avatarUrl] Avatar avatarUrl
         * @property {string|null} [color] Avatar color
         * @property {string|null} [contrastColor] Avatar contrastColor
         */

        /**
         * Constructs a new Avatar.
         * @memberof chat
         * @classdesc Represents an Avatar.
         * @implements IAvatar
         * @constructor
         * @param {chat.IAvatar=} [properties] Properties to set
         */
        function Avatar(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Avatar id.
         * @member {number} id
         * @memberof chat.Avatar
         * @instance
         */
        Avatar.prototype.id = 0;

        /**
         * Avatar username.
         * @member {string} username
         * @memberof chat.Avatar
         * @instance
         */
        Avatar.prototype.username = "";

        /**
         * Avatar gecos.
         * @member {string} gecos
         * @memberof chat.Avatar
         * @instance
         */
        Avatar.prototype.gecos = "";

        /**
         * Avatar avatarUrl.
         * @member {string} avatarUrl
         * @memberof chat.Avatar
         * @instance
         */
        Avatar.prototype.avatarUrl = "";

        /**
         * Avatar color.
         * @member {string} color
         * @memberof chat.Avatar
         * @instance
         */
        Avatar.prototype.color = "";

        /**
         * Avatar contrastColor.
         * @member {string} contrastColor
         * @memberof chat.Avatar
         * @instance
         */
        Avatar.prototype.contrastColor = "";

        /**
         * Creates a new Avatar instance using the specified properties.
         * @function create
         * @memberof chat.Avatar
         * @static
         * @param {chat.IAvatar=} [properties] Properties to set
         * @returns {chat.Avatar} Avatar instance
         */
        Avatar.create = function create(properties) {
            return new Avatar(properties);
        };

        /**
         * Encodes the specified Avatar message. Does not implicitly {@link chat.Avatar.verify|verify} messages.
         * @function encode
         * @memberof chat.Avatar
         * @static
         * @param {chat.IAvatar} message Avatar message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Avatar.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.username);
            if (message.gecos != null && Object.hasOwnProperty.call(message, "gecos"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.gecos);
            if (message.avatarUrl != null && Object.hasOwnProperty.call(message, "avatarUrl"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.avatarUrl);
            if (message.color != null && Object.hasOwnProperty.call(message, "color"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.color);
            if (message.contrastColor != null && Object.hasOwnProperty.call(message, "contrastColor"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.contrastColor);
            return writer;
        };

        /**
         * Encodes the specified Avatar message, length delimited. Does not implicitly {@link chat.Avatar.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.Avatar
         * @static
         * @param {chat.IAvatar} message Avatar message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Avatar.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Avatar message from the specified reader or buffer.
         * @function decode
         * @memberof chat.Avatar
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.Avatar} Avatar
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Avatar.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.Avatar();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.int32();
                        break;
                    }
                case 2: {
                        message.username = reader.string();
                        break;
                    }
                case 3: {
                        message.gecos = reader.string();
                        break;
                    }
                case 4: {
                        message.avatarUrl = reader.string();
                        break;
                    }
                case 5: {
                        message.color = reader.string();
                        break;
                    }
                case 6: {
                        message.contrastColor = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Avatar message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.Avatar
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.Avatar} Avatar
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Avatar.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Avatar message.
         * @function verify
         * @memberof chat.Avatar
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Avatar.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isInteger(message.id))
                    return "id: integer expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.gecos != null && message.hasOwnProperty("gecos"))
                if (!$util.isString(message.gecos))
                    return "gecos: string expected";
            if (message.avatarUrl != null && message.hasOwnProperty("avatarUrl"))
                if (!$util.isString(message.avatarUrl))
                    return "avatarUrl: string expected";
            if (message.color != null && message.hasOwnProperty("color"))
                if (!$util.isString(message.color))
                    return "color: string expected";
            if (message.contrastColor != null && message.hasOwnProperty("contrastColor"))
                if (!$util.isString(message.contrastColor))
                    return "contrastColor: string expected";
            return null;
        };

        /**
         * Creates an Avatar message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.Avatar
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.Avatar} Avatar
         */
        Avatar.fromObject = function fromObject(object, long) {
            if (object instanceof $root.chat.Avatar)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var message = new $root.chat.Avatar();
            if (object.id != null)
                message.id = object.id | 0;
            if (object.username != null)
                message.username = String(object.username);
            if (object.gecos != null)
                message.gecos = String(object.gecos);
            if (object.avatarUrl != null)
                message.avatarUrl = String(object.avatarUrl);
            if (object.color != null)
                message.color = String(object.color);
            if (object.contrastColor != null)
                message.contrastColor = String(object.contrastColor);
            return message;
        };

        /**
         * Creates a plain object from an Avatar message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.Avatar
         * @static
         * @param {chat.Avatar} message Avatar
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Avatar.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = 0;
                object.username = "";
                object.gecos = "";
                object.avatarUrl = "";
                object.color = "";
                object.contrastColor = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.gecos != null && message.hasOwnProperty("gecos"))
                object.gecos = message.gecos;
            if (message.avatarUrl != null && message.hasOwnProperty("avatarUrl"))
                object.avatarUrl = message.avatarUrl;
            if (message.color != null && message.hasOwnProperty("color"))
                object.color = message.color;
            if (message.contrastColor != null && message.hasOwnProperty("contrastColor"))
                object.contrastColor = message.contrastColor;
            return object;
        };

        /**
         * Converts this Avatar to JSON.
         * @function toJSON
         * @memberof chat.Avatar
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Avatar.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Avatar
         * @function getTypeUrl
         * @memberof chat.Avatar
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Avatar.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.Avatar";
        };

        return Avatar;
    })();

    chat.Timestamp = (function() {

        /**
         * Properties of a Timestamp.
         * @memberof chat
         * @interface ITimestamp
         * @property {number|Long|null} [unixMsec] Timestamp unixMsec
         */

        /**
         * Constructs a new Timestamp.
         * @memberof chat
         * @classdesc Represents a Timestamp.
         * @implements ITimestamp
         * @constructor
         * @param {chat.ITimestamp=} [properties] Properties to set
         */
        function Timestamp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Timestamp unixMsec.
         * @member {number|Long} unixMsec
         * @memberof chat.Timestamp
         * @instance
         */
        Timestamp.prototype.unixMsec = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new Timestamp instance using the specified properties.
         * @function create
         * @memberof chat.Timestamp
         * @static
         * @param {chat.ITimestamp=} [properties] Properties to set
         * @returns {chat.Timestamp} Timestamp instance
         */
        Timestamp.create = function create(properties) {
            return new Timestamp(properties);
        };

        /**
         * Encodes the specified Timestamp message. Does not implicitly {@link chat.Timestamp.verify|verify} messages.
         * @function encode
         * @memberof chat.Timestamp
         * @static
         * @param {chat.ITimestamp} message Timestamp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Timestamp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.unixMsec != null && Object.hasOwnProperty.call(message, "unixMsec"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.unixMsec);
            return writer;
        };

        /**
         * Encodes the specified Timestamp message, length delimited. Does not implicitly {@link chat.Timestamp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.Timestamp
         * @static
         * @param {chat.ITimestamp} message Timestamp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Timestamp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Timestamp message from the specified reader or buffer.
         * @function decode
         * @memberof chat.Timestamp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.Timestamp} Timestamp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Timestamp.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.Timestamp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.unixMsec = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Timestamp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.Timestamp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.Timestamp} Timestamp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Timestamp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Timestamp message.
         * @function verify
         * @memberof chat.Timestamp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Timestamp.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            if (message.unixMsec != null && message.hasOwnProperty("unixMsec"))
                if (!$util.isInteger(message.unixMsec) && !(message.unixMsec && $util.isInteger(message.unixMsec.low) && $util.isInteger(message.unixMsec.high)))
                    return "unixMsec: integer|Long expected";
            return null;
        };

        /**
         * Creates a Timestamp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.Timestamp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.Timestamp} Timestamp
         */
        Timestamp.fromObject = function fromObject(object, long) {
            if (object instanceof $root.chat.Timestamp)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var message = new $root.chat.Timestamp();
            if (object.unixMsec != null)
                if ($util.Long)
                    (message.unixMsec = $util.Long.fromValue(object.unixMsec)).unsigned = true;
                else if (typeof object.unixMsec === "string")
                    message.unixMsec = parseInt(object.unixMsec, 10);
                else if (typeof object.unixMsec === "number")
                    message.unixMsec = object.unixMsec;
                else if (typeof object.unixMsec === "object")
                    message.unixMsec = new $util.LongBits(object.unixMsec.low >>> 0, object.unixMsec.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a Timestamp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.Timestamp
         * @static
         * @param {chat.Timestamp} message Timestamp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Timestamp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.unixMsec = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.unixMsec = options.longs === String ? "0" : 0;
            if (message.unixMsec != null && message.hasOwnProperty("unixMsec"))
                if (typeof message.unixMsec === "number")
                    object.unixMsec = options.longs === String ? String(message.unixMsec) : message.unixMsec;
                else
                    object.unixMsec = options.longs === String ? $util.Long.prototype.toString.call(message.unixMsec) : options.longs === Number ? new $util.LongBits(message.unixMsec.low >>> 0, message.unixMsec.high >>> 0).toNumber(true) : message.unixMsec;
            return object;
        };

        /**
         * Converts this Timestamp to JSON.
         * @function toJSON
         * @memberof chat.Timestamp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Timestamp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Timestamp
         * @function getTypeUrl
         * @memberof chat.Timestamp
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Timestamp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.Timestamp";
        };

        return Timestamp;
    })();

    chat.SendChatMessageRequest = (function() {

        /**
         * Properties of a SendChatMessageRequest.
         * @memberof chat
         * @interface ISendChatMessageRequest
         * @property {string|null} [chatId] SendChatMessageRequest chatId
         * @property {string|null} [eventId] SendChatMessageRequest eventId
         * @property {string|null} [groupId] SendChatMessageRequest groupId
         * @property {string|null} [userId] SendChatMessageRequest userId
         * @property {string|null} [clientMessageId] SendChatMessageRequest clientMessageId
         * @property {string|null} [inReplyTo] SendChatMessageRequest inReplyTo
         * @property {string|null} [text] SendChatMessageRequest text
         * @property {Array.<Uint8Array>|null} [attachments] SendChatMessageRequest attachments
         * @property {string|null} [reaction] SendChatMessageRequest reaction
         * @property {string|null} [replacesId] SendChatMessageRequest replacesId
         * @property {string|null} [deletesId] SendChatMessageRequest deletesId
         */

        /**
         * Constructs a new SendChatMessageRequest.
         * @memberof chat
         * @classdesc Represents a SendChatMessageRequest.
         * @implements ISendChatMessageRequest
         * @constructor
         * @param {chat.ISendChatMessageRequest=} [properties] Properties to set
         */
        function SendChatMessageRequest(properties) {
            this.attachments = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SendChatMessageRequest chatId.
         * @member {string|null|undefined} chatId
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.chatId = null;

        /**
         * SendChatMessageRequest eventId.
         * @member {string|null|undefined} eventId
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.eventId = null;

        /**
         * SendChatMessageRequest groupId.
         * @member {string|null|undefined} groupId
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.groupId = null;

        /**
         * SendChatMessageRequest userId.
         * @member {string|null|undefined} userId
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.userId = null;

        /**
         * SendChatMessageRequest clientMessageId.
         * @member {string} clientMessageId
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.clientMessageId = "";

        /**
         * SendChatMessageRequest inReplyTo.
         * @member {string} inReplyTo
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.inReplyTo = "";

        /**
         * SendChatMessageRequest text.
         * @member {string} text
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.text = "";

        /**
         * SendChatMessageRequest attachments.
         * @member {Array.<Uint8Array>} attachments
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.attachments = $util.emptyArray;

        /**
         * SendChatMessageRequest reaction.
         * @member {string} reaction
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.reaction = "";

        /**
         * SendChatMessageRequest replacesId.
         * @member {string} replacesId
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.replacesId = "";

        /**
         * SendChatMessageRequest deletesId.
         * @member {string} deletesId
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        SendChatMessageRequest.prototype.deletesId = "";

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * SendChatMessageRequest recipient.
         * @member {"chatId"|"eventId"|"groupId"|"userId"|undefined} recipient
         * @memberof chat.SendChatMessageRequest
         * @instance
         */
        Object.defineProperty(SendChatMessageRequest.prototype, "recipient", {
            get: $util.oneOfGetter($oneOfFields = ["chatId", "eventId", "groupId", "userId"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SendChatMessageRequest instance using the specified properties.
         * @function create
         * @memberof chat.SendChatMessageRequest
         * @static
         * @param {chat.ISendChatMessageRequest=} [properties] Properties to set
         * @returns {chat.SendChatMessageRequest} SendChatMessageRequest instance
         */
        SendChatMessageRequest.create = function create(properties) {
            return new SendChatMessageRequest(properties);
        };

        /**
         * Encodes the specified SendChatMessageRequest message. Does not implicitly {@link chat.SendChatMessageRequest.verify|verify} messages.
         * @function encode
         * @memberof chat.SendChatMessageRequest
         * @static
         * @param {chat.ISendChatMessageRequest} message SendChatMessageRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendChatMessageRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.chatId);
            if (message.eventId != null && Object.hasOwnProperty.call(message, "eventId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.eventId);
            if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.groupId);
            if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.userId);
            if (message.clientMessageId != null && Object.hasOwnProperty.call(message, "clientMessageId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.clientMessageId);
            if (message.inReplyTo != null && Object.hasOwnProperty.call(message, "inReplyTo"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.inReplyTo);
            if (message.text != null && Object.hasOwnProperty.call(message, "text"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.text);
            if (message.attachments != null && message.attachments.length)
                for (var i = 0; i < message.attachments.length; ++i)
                    writer.uint32(/* id 8, wireType 2 =*/66).bytes(message.attachments[i]);
            if (message.reaction != null && Object.hasOwnProperty.call(message, "reaction"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.reaction);
            if (message.replacesId != null && Object.hasOwnProperty.call(message, "replacesId"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.replacesId);
            if (message.deletesId != null && Object.hasOwnProperty.call(message, "deletesId"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.deletesId);
            return writer;
        };

        /**
         * Encodes the specified SendChatMessageRequest message, length delimited. Does not implicitly {@link chat.SendChatMessageRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.SendChatMessageRequest
         * @static
         * @param {chat.ISendChatMessageRequest} message SendChatMessageRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendChatMessageRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SendChatMessageRequest message from the specified reader or buffer.
         * @function decode
         * @memberof chat.SendChatMessageRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.SendChatMessageRequest} SendChatMessageRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendChatMessageRequest.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.SendChatMessageRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.chatId = reader.string();
                        break;
                    }
                case 2: {
                        message.eventId = reader.string();
                        break;
                    }
                case 3: {
                        message.groupId = reader.string();
                        break;
                    }
                case 4: {
                        message.userId = reader.string();
                        break;
                    }
                case 5: {
                        message.clientMessageId = reader.string();
                        break;
                    }
                case 6: {
                        message.inReplyTo = reader.string();
                        break;
                    }
                case 7: {
                        message.text = reader.string();
                        break;
                    }
                case 8: {
                        if (!(message.attachments && message.attachments.length))
                            message.attachments = [];
                        message.attachments.push(reader.bytes());
                        break;
                    }
                case 9: {
                        message.reaction = reader.string();
                        break;
                    }
                case 10: {
                        message.replacesId = reader.string();
                        break;
                    }
                case 11: {
                        message.deletesId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SendChatMessageRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.SendChatMessageRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.SendChatMessageRequest} SendChatMessageRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendChatMessageRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SendChatMessageRequest message.
         * @function verify
         * @memberof chat.SendChatMessageRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SendChatMessageRequest.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            var properties = {};
            if (message.chatId != null && message.hasOwnProperty("chatId")) {
                properties.recipient = 1;
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            }
            if (message.eventId != null && message.hasOwnProperty("eventId")) {
                if (properties.recipient === 1)
                    return "recipient: multiple values";
                properties.recipient = 1;
                if (!$util.isString(message.eventId))
                    return "eventId: string expected";
            }
            if (message.groupId != null && message.hasOwnProperty("groupId")) {
                if (properties.recipient === 1)
                    return "recipient: multiple values";
                properties.recipient = 1;
                if (!$util.isString(message.groupId))
                    return "groupId: string expected";
            }
            if (message.userId != null && message.hasOwnProperty("userId")) {
                if (properties.recipient === 1)
                    return "recipient: multiple values";
                properties.recipient = 1;
                if (!$util.isString(message.userId))
                    return "userId: string expected";
            }
            if (message.clientMessageId != null && message.hasOwnProperty("clientMessageId"))
                if (!$util.isString(message.clientMessageId))
                    return "clientMessageId: string expected";
            if (message.inReplyTo != null && message.hasOwnProperty("inReplyTo"))
                if (!$util.isString(message.inReplyTo))
                    return "inReplyTo: string expected";
            if (message.text != null && message.hasOwnProperty("text"))
                if (!$util.isString(message.text))
                    return "text: string expected";
            if (message.attachments != null && message.hasOwnProperty("attachments")) {
                if (!Array.isArray(message.attachments))
                    return "attachments: array expected";
                for (var i = 0; i < message.attachments.length; ++i)
                    if (!(message.attachments[i] && typeof message.attachments[i].length === "number" || $util.isString(message.attachments[i])))
                        return "attachments: buffer[] expected";
            }
            if (message.reaction != null && message.hasOwnProperty("reaction"))
                if (!$util.isString(message.reaction))
                    return "reaction: string expected";
            if (message.replacesId != null && message.hasOwnProperty("replacesId"))
                if (!$util.isString(message.replacesId))
                    return "replacesId: string expected";
            if (message.deletesId != null && message.hasOwnProperty("deletesId"))
                if (!$util.isString(message.deletesId))
                    return "deletesId: string expected";
            return null;
        };

        /**
         * Creates a SendChatMessageRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.SendChatMessageRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.SendChatMessageRequest} SendChatMessageRequest
         */
        SendChatMessageRequest.fromObject = function fromObject(object, long) {
            if (object instanceof $root.chat.SendChatMessageRequest)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var message = new $root.chat.SendChatMessageRequest();
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            if (object.eventId != null)
                message.eventId = String(object.eventId);
            if (object.groupId != null)
                message.groupId = String(object.groupId);
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.clientMessageId != null)
                message.clientMessageId = String(object.clientMessageId);
            if (object.inReplyTo != null)
                message.inReplyTo = String(object.inReplyTo);
            if (object.text != null)
                message.text = String(object.text);
            if (object.attachments) {
                if (!Array.isArray(object.attachments))
                    throw TypeError(".chat.SendChatMessageRequest.attachments: array expected");
                message.attachments = [];
                for (var i = 0; i < object.attachments.length; ++i)
                    if (typeof object.attachments[i] === "string")
                        $util.base64.decode(object.attachments[i], message.attachments[i] = $util.newBuffer($util.base64.length(object.attachments[i])), 0);
                    else if (object.attachments[i].length >= 0)
                        message.attachments[i] = object.attachments[i];
            }
            if (object.reaction != null)
                message.reaction = String(object.reaction);
            if (object.replacesId != null)
                message.replacesId = String(object.replacesId);
            if (object.deletesId != null)
                message.deletesId = String(object.deletesId);
            return message;
        };

        /**
         * Creates a plain object from a SendChatMessageRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.SendChatMessageRequest
         * @static
         * @param {chat.SendChatMessageRequest} message SendChatMessageRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SendChatMessageRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.attachments = [];
            if (options.defaults) {
                object.clientMessageId = "";
                object.inReplyTo = "";
                object.text = "";
                object.reaction = "";
                object.replacesId = "";
                object.deletesId = "";
            }
            if (message.chatId != null && message.hasOwnProperty("chatId")) {
                object.chatId = message.chatId;
                if (options.oneofs)
                    object.recipient = "chatId";
            }
            if (message.eventId != null && message.hasOwnProperty("eventId")) {
                object.eventId = message.eventId;
                if (options.oneofs)
                    object.recipient = "eventId";
            }
            if (message.groupId != null && message.hasOwnProperty("groupId")) {
                object.groupId = message.groupId;
                if (options.oneofs)
                    object.recipient = "groupId";
            }
            if (message.userId != null && message.hasOwnProperty("userId")) {
                object.userId = message.userId;
                if (options.oneofs)
                    object.recipient = "userId";
            }
            if (message.clientMessageId != null && message.hasOwnProperty("clientMessageId"))
                object.clientMessageId = message.clientMessageId;
            if (message.inReplyTo != null && message.hasOwnProperty("inReplyTo"))
                object.inReplyTo = message.inReplyTo;
            if (message.text != null && message.hasOwnProperty("text"))
                object.text = message.text;
            if (message.attachments && message.attachments.length) {
                object.attachments = [];
                for (var j = 0; j < message.attachments.length; ++j)
                    object.attachments[j] = options.bytes === String ? $util.base64.encode(message.attachments[j], 0, message.attachments[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.attachments[j]) : message.attachments[j];
            }
            if (message.reaction != null && message.hasOwnProperty("reaction"))
                object.reaction = message.reaction;
            if (message.replacesId != null && message.hasOwnProperty("replacesId"))
                object.replacesId = message.replacesId;
            if (message.deletesId != null && message.hasOwnProperty("deletesId"))
                object.deletesId = message.deletesId;
            return object;
        };

        /**
         * Converts this SendChatMessageRequest to JSON.
         * @function toJSON
         * @memberof chat.SendChatMessageRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SendChatMessageRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SendChatMessageRequest
         * @function getTypeUrl
         * @memberof chat.SendChatMessageRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SendChatMessageRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.SendChatMessageRequest";
        };

        return SendChatMessageRequest;
    })();

    chat.ChatMessage = (function() {

        /**
         * Properties of a ChatMessage.
         * @memberof chat
         * @interface IChatMessage
         * @property {string|null} [messageId] ChatMessage messageId
         * @property {string|null} [chatId] ChatMessage chatId
         * @property {string|null} [clientMessageId] ChatMessage clientMessageId
         * @property {chat.IAvatar|null} [sender] ChatMessage sender
         * @property {chat.ITimestamp|null} [receivedAt] ChatMessage receivedAt
         * @property {string|null} [inReplyTo] ChatMessage inReplyTo
         * @property {string|null} [text] ChatMessage text
         * @property {Array.<string>|null} [thumbnailIds] ChatMessage thumbnailIds
         * @property {string|null} [reaction] ChatMessage reaction
         * @property {string|null} [replacesId] ChatMessage replacesId
         * @property {string|null} [deletesId] ChatMessage deletesId
         */

        /**
         * Constructs a new ChatMessage.
         * @memberof chat
         * @classdesc Represents a ChatMessage.
         * @implements IChatMessage
         * @constructor
         * @param {chat.IChatMessage=} [properties] Properties to set
         */
        function ChatMessage(properties) {
            this.thumbnailIds = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChatMessage messageId.
         * @member {string} messageId
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.messageId = "";

        /**
         * ChatMessage chatId.
         * @member {string} chatId
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.chatId = "";

        /**
         * ChatMessage clientMessageId.
         * @member {string} clientMessageId
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.clientMessageId = "";

        /**
         * ChatMessage sender.
         * @member {chat.IAvatar|null|undefined} sender
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.sender = null;

        /**
         * ChatMessage receivedAt.
         * @member {chat.ITimestamp|null|undefined} receivedAt
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.receivedAt = null;

        /**
         * ChatMessage inReplyTo.
         * @member {string} inReplyTo
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.inReplyTo = "";

        /**
         * ChatMessage text.
         * @member {string} text
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.text = "";

        /**
         * ChatMessage thumbnailIds.
         * @member {Array.<string>} thumbnailIds
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.thumbnailIds = $util.emptyArray;

        /**
         * ChatMessage reaction.
         * @member {string} reaction
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.reaction = "";

        /**
         * ChatMessage replacesId.
         * @member {string} replacesId
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.replacesId = "";

        /**
         * ChatMessage deletesId.
         * @member {string} deletesId
         * @memberof chat.ChatMessage
         * @instance
         */
        ChatMessage.prototype.deletesId = "";

        /**
         * Creates a new ChatMessage instance using the specified properties.
         * @function create
         * @memberof chat.ChatMessage
         * @static
         * @param {chat.IChatMessage=} [properties] Properties to set
         * @returns {chat.ChatMessage} ChatMessage instance
         */
        ChatMessage.create = function create(properties) {
            return new ChatMessage(properties);
        };

        /**
         * Encodes the specified ChatMessage message. Does not implicitly {@link chat.ChatMessage.verify|verify} messages.
         * @function encode
         * @memberof chat.ChatMessage
         * @static
         * @param {chat.IChatMessage} message ChatMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatMessage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.messageId);
            if (message.chatId != null && Object.hasOwnProperty.call(message, "chatId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.chatId);
            if (message.clientMessageId != null && Object.hasOwnProperty.call(message, "clientMessageId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.clientMessageId);
            if (message.sender != null && Object.hasOwnProperty.call(message, "sender"))
                $root.chat.Avatar.encode(message.sender, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.receivedAt != null && Object.hasOwnProperty.call(message, "receivedAt"))
                $root.chat.Timestamp.encode(message.receivedAt, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.inReplyTo != null && Object.hasOwnProperty.call(message, "inReplyTo"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.inReplyTo);
            if (message.text != null && Object.hasOwnProperty.call(message, "text"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.text);
            if (message.thumbnailIds != null && message.thumbnailIds.length)
                for (var i = 0; i < message.thumbnailIds.length; ++i)
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.thumbnailIds[i]);
            if (message.reaction != null && Object.hasOwnProperty.call(message, "reaction"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.reaction);
            if (message.replacesId != null && Object.hasOwnProperty.call(message, "replacesId"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.replacesId);
            if (message.deletesId != null && Object.hasOwnProperty.call(message, "deletesId"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.deletesId);
            return writer;
        };

        /**
         * Encodes the specified ChatMessage message, length delimited. Does not implicitly {@link chat.ChatMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chat.ChatMessage
         * @static
         * @param {chat.IChatMessage} message ChatMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatMessage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ChatMessage message from the specified reader or buffer.
         * @function decode
         * @memberof chat.ChatMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chat.ChatMessage} ChatMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatMessage.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.chat.ChatMessage();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.messageId = reader.string();
                        break;
                    }
                case 2: {
                        message.chatId = reader.string();
                        break;
                    }
                case 3: {
                        message.clientMessageId = reader.string();
                        break;
                    }
                case 4: {
                        message.sender = $root.chat.Avatar.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 5: {
                        message.receivedAt = $root.chat.Timestamp.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 6: {
                        message.inReplyTo = reader.string();
                        break;
                    }
                case 7: {
                        message.text = reader.string();
                        break;
                    }
                case 8: {
                        if (!(message.thumbnailIds && message.thumbnailIds.length))
                            message.thumbnailIds = [];
                        message.thumbnailIds.push(reader.string());
                        break;
                    }
                case 9: {
                        message.reaction = reader.string();
                        break;
                    }
                case 10: {
                        message.replacesId = reader.string();
                        break;
                    }
                case 11: {
                        message.deletesId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ChatMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chat.ChatMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chat.ChatMessage} ChatMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatMessage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChatMessage message.
         * @function verify
         * @memberof chat.ChatMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChatMessage.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                if (!$util.isString(message.chatId))
                    return "chatId: string expected";
            if (message.clientMessageId != null && message.hasOwnProperty("clientMessageId"))
                if (!$util.isString(message.clientMessageId))
                    return "clientMessageId: string expected";
            if (message.sender != null && message.hasOwnProperty("sender")) {
                var error = $root.chat.Avatar.verify(message.sender, long + 1);
                if (error)
                    return "sender." + error;
            }
            if (message.receivedAt != null && message.hasOwnProperty("receivedAt")) {
                var error = $root.chat.Timestamp.verify(message.receivedAt, long + 1);
                if (error)
                    return "receivedAt." + error;
            }
            if (message.inReplyTo != null && message.hasOwnProperty("inReplyTo"))
                if (!$util.isString(message.inReplyTo))
                    return "inReplyTo: string expected";
            if (message.text != null && message.hasOwnProperty("text"))
                if (!$util.isString(message.text))
                    return "text: string expected";
            if (message.thumbnailIds != null && message.hasOwnProperty("thumbnailIds")) {
                if (!Array.isArray(message.thumbnailIds))
                    return "thumbnailIds: array expected";
                for (var i = 0; i < message.thumbnailIds.length; ++i)
                    if (!$util.isString(message.thumbnailIds[i]))
                        return "thumbnailIds: string[] expected";
            }
            if (message.reaction != null && message.hasOwnProperty("reaction"))
                if (!$util.isString(message.reaction))
                    return "reaction: string expected";
            if (message.replacesId != null && message.hasOwnProperty("replacesId"))
                if (!$util.isString(message.replacesId))
                    return "replacesId: string expected";
            if (message.deletesId != null && message.hasOwnProperty("deletesId"))
                if (!$util.isString(message.deletesId))
                    return "deletesId: string expected";
            return null;
        };

        /**
         * Creates a ChatMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chat.ChatMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chat.ChatMessage} ChatMessage
         */
        ChatMessage.fromObject = function fromObject(object, long) {
            if (object instanceof $root.chat.ChatMessage)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            var message = new $root.chat.ChatMessage();
            if (object.messageId != null)
                message.messageId = String(object.messageId);
            if (object.chatId != null)
                message.chatId = String(object.chatId);
            if (object.clientMessageId != null)
                message.clientMessageId = String(object.clientMessageId);
            if (object.sender != null) {
                if (typeof object.sender !== "object")
                    throw TypeError(".chat.ChatMessage.sender: object expected");
                message.sender = $root.chat.Avatar.fromObject(object.sender, long + 1);
            }
            if (object.receivedAt != null) {
                if (typeof object.receivedAt !== "object")
                    throw TypeError(".chat.ChatMessage.receivedAt: object expected");
                message.receivedAt = $root.chat.Timestamp.fromObject(object.receivedAt, long + 1);
            }
            if (object.inReplyTo != null)
                message.inReplyTo = String(object.inReplyTo);
            if (object.text != null)
                message.text = String(object.text);
            if (object.thumbnailIds) {
                if (!Array.isArray(object.thumbnailIds))
                    throw TypeError(".chat.ChatMessage.thumbnailIds: array expected");
                message.thumbnailIds = [];
                for (var i = 0; i < object.thumbnailIds.length; ++i)
                    message.thumbnailIds[i] = String(object.thumbnailIds[i]);
            }
            if (object.reaction != null)
                message.reaction = String(object.reaction);
            if (object.replacesId != null)
                message.replacesId = String(object.replacesId);
            if (object.deletesId != null)
                message.deletesId = String(object.deletesId);
            return message;
        };

        /**
         * Creates a plain object from a ChatMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chat.ChatMessage
         * @static
         * @param {chat.ChatMessage} message ChatMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChatMessage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.thumbnailIds = [];
            if (options.defaults) {
                object.messageId = "";
                object.chatId = "";
                object.clientMessageId = "";
                object.sender = null;
                object.receivedAt = null;
                object.inReplyTo = "";
                object.text = "";
                object.reaction = "";
                object.replacesId = "";
                object.deletesId = "";
            }
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                object.messageId = message.messageId;
            if (message.chatId != null && message.hasOwnProperty("chatId"))
                object.chatId = message.chatId;
            if (message.clientMessageId != null && message.hasOwnProperty("clientMessageId"))
                object.clientMessageId = message.clientMessageId;
            if (message.sender != null && message.hasOwnProperty("sender"))
                object.sender = $root.chat.Avatar.toObject(message.sender, options);
            if (message.receivedAt != null && message.hasOwnProperty("receivedAt"))
                object.receivedAt = $root.chat.Timestamp.toObject(message.receivedAt, options);
            if (message.inReplyTo != null && message.hasOwnProperty("inReplyTo"))
                object.inReplyTo = message.inReplyTo;
            if (message.text != null && message.hasOwnProperty("text"))
                object.text = message.text;
            if (message.thumbnailIds && message.thumbnailIds.length) {
                object.thumbnailIds = [];
                for (var j = 0; j < message.thumbnailIds.length; ++j)
                    object.thumbnailIds[j] = message.thumbnailIds[j];
            }
            if (message.reaction != null && message.hasOwnProperty("reaction"))
                object.reaction = message.reaction;
            if (message.replacesId != null && message.hasOwnProperty("replacesId"))
                object.replacesId = message.replacesId;
            if (message.deletesId != null && message.hasOwnProperty("deletesId"))
                object.deletesId = message.deletesId;
            return object;
        };

        /**
         * Converts this ChatMessage to JSON.
         * @function toJSON
         * @memberof chat.ChatMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChatMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ChatMessage
         * @function getTypeUrl
         * @memberof chat.ChatMessage
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ChatMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chat.ChatMessage";
        };

        return ChatMessage;
    })();

    return chat;
})();

module.exports = $root;
